var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 14.5,
    viewBox: "0 0 14.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-5208247",
    transform: "translate(-100 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247814",
    "data-name": "Path 247814",
    d: "M774.47,102.829,771.64,100l-1.96,1.96,2.829,2.829Z",
    transform: "translate(-659.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247815",
    "data-name": "Path 247815",
    d: "M300,324.486l3.112-.283,5.356-5.356-2.829-2.829-5.356,5.356Z",
    transform: "translate(-197.1 -212.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247816",
    "data-name": "Path 247816",
    d: "M109.425,1001.45H100V1000h9.425Z",
    transform: "translate(0 -886.95)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.93d881674eebcb2ad59d3276316221a1.svg";
export { ForwardRef as ReactComponent };